/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{addUniqueItem as s,removeItem as t}from"./array.js";class i{constructor(){this.subscriptions=[]}add(i){return s(this.subscriptions,i),()=>t(this.subscriptions,i)}notify(s,t,i){const r=this.subscriptions.length;if(r)if(1===r)this.subscriptions[0](s,t,i);else for(let n=0;n<r;n++){const r=this.subscriptions[n];r&&r(s,t,i)}}getSize(){return this.subscriptions.length}clear(){this.subscriptions.length=0}}export{i as SubscriptionManager};
//# sourceMappingURL=subscription-manager.js.map
